import React from 'react';
import styles from './enrichment-custom-attributes.module.sass';
import { Collapse, Typography, Tooltip, Table } from 'antd';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import ProgressBar from '../../../../shared-components/ProgressBar';
import ScoreBadge from '../../../../shared-components/ScoreBadge';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import { InfoCircleFilled } from '@ant-design/icons';

function EnrichmentCustomAttributes({ oldData, statusOld, statusNew, type }) {
  const { Title, Text, Paragraph } = Typography;
  const { Panel } = Collapse;

  function customAttributesHeader() {
    return (
      <div className={styles.header}>
        <Tooltip title="A cumulative score that includes all custom attributes">
          <Text className={styles.empty_text}>&nbsp;</Text>
          <ScoreBadge
            score={oldData?.total_custom}
            scoreTextRecolor={false}
            scoreProgressRecolor={false}
            boxBordered={false}
          />
        </Tooltip>
        <Title level={4} className={styles.component_title}>
          Custom Attributes
        </Title>
      </div>
    );
  }

  const columns = [
    {
      title: <ColumnTitle columnName="Name" />,
      dataIndex: 'name',
      key: 'name',
      width: 300,
      render: (value, params) => {
        if (params?.tooltip) {
          return (
            <>
              {value + ' '}
              <Tooltip placement="top" title={params?.tooltip}>
                <InfoCircleFilled />
              </Tooltip>
            </>
          );
        } else {
          return value;
        }
      },
    },
    {
      title: <ColumnTitle columnName="Value" />,
      dataIndex: 'value',
      key: 'value',
      width: 100,
    },
    {
      title: <ColumnTitle columnName="Score" />,
      dataIndex: 'progress',
      key: 'progress',
    },
  ];

  function returnTableData({ loading, iocType }) {
    if (iocType === 'domain') {
      return [
        {
          key: 1,
          name: 'Customer Domain Score',
          tooltip: `A score that indicates an observable's similarity to other domains`,
          value: loading ? (
            <LoadingSkeleton />
          ) : (
            <Text strong>
              {oldData?.customer_domain_score ||
              oldData?.customer_domain_score == 0
                ? oldData?.customer_domain_score
                : '-'}
            </Text>
          ),
          progress: loading ? (
            <LoadingSkeleton />
          ) : (
            <ProgressBar
              bgcolor={oldData?.customer_domain_score}
              width={'72'}
              completed={oldData?.customer_domain_score}
            />
          ),
        },
        {
          key: 2,
          name: 'Top Brand Domain Score',
          tooltip: `A score that indicates an observable's similarity to top brands domains`,
          value: loading ? (
            <LoadingSkeleton />
          ) : (
            <Text strong>
              {oldData?.top_brands_domain_score ||
              oldData?.top_brands_domain_score == 0
                ? oldData?.top_brands_domain_score
                : '-'}
            </Text>
          ),
          progress: loading ? (
            <LoadingSkeleton />
          ) : (
            <ProgressBar
              bgcolor={oldData?.top_brands_domain_score}
              width={'72'}
              completed={oldData?.top_brands_domain_score}
            />
          ),
        },
        {
          key: 3,
          name: 'Supplier Domain Score',
          tooltip: `A score expressing an observable's similarity to your organization's designated supplier domains`,
          value: loading ? (
            <LoadingSkeleton />
          ) : (
            <Text strong>
              {oldData?.supplier_domain_score ||
              oldData?.supplier_domain_score == 0
                ? oldData?.supplier_domain_score
                : '-'}
            </Text>
          ),
          progress: loading ? (
            <LoadingSkeleton />
          ) : (
            <ProgressBar
              bgcolor={oldData?.supplier_domain_score}
              width={'72'}
              completed={oldData?.supplier_domain_score}
            />
          ),
        },
      ];
    } else if (iocType === 'ipv4') {
      return [
        {
          key: 1,
          name: 'IP Geo',
          tooltip: `A calculated score expressing the IP's presence in an organization's designated area of operation`,
          value: loading ? (
            <LoadingSkeleton />
          ) : (
            <Text strong>
              {oldData?.geo_ip_score || oldData?.geo_ip_score == 0
                ? oldData?.geo_ip_score
                : '-'}
            </Text>
          ),
          progress: loading ? (
            <LoadingSkeleton />
          ) : (
            <ProgressBar
              bgcolor={oldData?.geo_ip_score}
              width={'72'}
              completed={oldData?.geo_ip_score}
            />
          ),
        },
        {
          key: 2,
          name: 'IP Range',
          tooltip: 'How an IP address matches up to an IP Range',
          value: loading ? (
            <LoadingSkeleton />
          ) : (
            <Text strong>
              {oldData?.ip_range_score || oldData?.ip_range_score == 0
                ? oldData?.ip_range_score
                : '-'}
            </Text>
          ),
          progress: loading ? (
            <LoadingSkeleton />
          ) : (
            <ProgressBar
              bgcolor={oldData?.ip_range_score}
              width={'72'}
              completed={oldData?.ip_range_score}
            />
          ),
        },
      ];
    }
  }

  return (
    <div className={styles.enrichment_custom_attributes}>
      <Collapse defaultActiveKey={['1']} expandIconPosition={'end'}>
        <Panel header={customAttributesHeader()} key="1">
          <div className={styles.title}>
            <Title level={4}>Organization assets indicators</Title>
            <Text>
              A customer specific scoring used to tailor made Threat
              Intelligence feed items according to client's business assets or
              supply chain assets (domains and IPs).{' '}
              <Text strong>Silent Push invention</Text>
            </Text>
          </div>

          <Table
            columns={columns}
            pagination={false}
            dataSource={returnTableData({
              loading: statusNew !== 'loaded',
              iocType: type,
            })}
          />
        </Panel>
      </Collapse>
    </div>
  );
}

export default EnrichmentCustomAttributes;
